<template>
  <div class="unit-activity-config">
    <el-card>
      <header class="unit-activity-config__header">活动组件化配置</header>
      <div class="unit-activity-config__search">
        <div class="search-item">
          <span class="search-label">状态:</span>
          <el-select filterable v-model="searchData.status" placeholder="请选择">
            <el-option v-for="item in searchConst.status" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="search-item">
          <span class="search-label">活动码:</span>
          <el-input v-model="searchData.eventCode" placeholder="请输入活动码" clearable></el-input>
        </div>
        <div class="search-item">
          <span class="search-label">活动名称:</span>
          <el-input v-model="searchData.name" placeholder="请输入活动名称" clearable></el-input>
        </div>
        <div class="search-item">
          <span class="search-label">时区:</span>
          <el-select filterable v-model="searchData.zoneOffset" placeholder="请选择">
            <el-option v-for="item in searchConst.zoneOffset" :key="item.value" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="search-item">
          <span class="search-label">是否有效:</span>
          <el-select filterable v-model="searchData.valid" placeholder="请选择">
            <el-option v-for="item in searchConst.valid" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="search-actions">
          <el-button type="primary" @click="getUnitEventList">查询</el-button>
          <el-button type="success" @click="dialogShow(true)">新增</el-button>
          <el-button type="info" @click="checkAwardsKeysByEventCode">检查礼包Key</el-button>
          <el-button type="warning" @click="showImportDialog">导入配置</el-button>
        </div>
      </div>

      <!-- 新增：活动成本查询区域 -->
      <div class="cost-query-section">
        <span style="font-weight: bold;">活动成本查询：</span>
        <el-input v-model="costQueryEventCode" placeholder="请输入活动码" style="width: 200px; margin: 0 10px;" clearable>
        </el-input>
        <el-button type="primary" @click="quickQueryCost" :loading="costQueryLoading">查询成本</el-button>
      </div>

      <el-table :data="tableData" :height="450" align="center" stripe border>
        <el-table-column label="活动时间" width="180" align="center" fixed="left">
          <template #default="{ row }">
            <div class="time-cell">
              <div><i class="el-icon-timer"></i>{{ formatDate(row.startTime) }}</div>
              <div class="time-divider">~</div>
              <div>{{ formatDate(row.endTime) }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="活动名称" align="center" width="150" show-overflow-tooltip>
          <template #default="{ row }">
            <div class="name-cell">{{ row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="eventCode" label="活动Code" align="center" width="120"></el-table-column>
        <el-table-column label="成本信息" align="center" width="120">
          <template #default="{ row }">
            <div class="cost-cell">
              <div>限制: {{ formatNumber(row.maxCostLimit) || 0 }}</div>
              <div>当前: {{ formatNumber(row.currCost) || 0 }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="valid" label="是否有效" align="center" width="90">
          <template #default="{ row }">
            <el-tag :type="row.valid === 1 ? 'success' : 'danger'" size="small">
              {{ row.valid === 1 ? '有效' : '无效' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="fuse" label="是否熔断/熔断时间" align="center" width="180">
          <template #default="{ row }">
            <div style="display: flex; flex-direction: column; align-items: center; gap: 4px;">
              <el-tag :type="row.fuse === 1 ? 'danger' : 'success'" size="small">
                {{ row.fuse === 1 ? '是' : '否' }}
              </el-tag>
              <span style="font-size: 12px; color: #909399;">
                {{ row.fuseTime ? formatDate(row.fuseTime) : '-' }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="activeStatus" label="活动状态" align="center" width="100">
          <template #default="{ row }">
            <el-tag :type="getStatusTagType(row.activeStatus)" size="small">
              {{ row.activeStatus }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="url" label="活动URL" align="center" width="420" show-overflow-tooltip>
          <template #default="{ row }">
            <div class="url-cell">
              <el-link style="font-size: 12px; " type="primary" :underline="false" :href="row.url" target="_blank"
                class="url-link">
                {{ row.url }}
              </el-link>
              <el-button size="mini" icon="el-icon-copy-document" @click="copy(row.url)" class="copy-btn">复制</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="eventDesc" label="活动描述" align="center" width="180" show-overflow-tooltip>
          <template #default="{ row }">
            <div class="desc-cell">{{ row.eventDesc || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="组件数量" align="center" width="100">
          <template #default="{ row }">
            <span>{{ row.units ? row.units.length : 0 }}个</span>
          </template>
        </el-table-column>
        <el-table-column label="修改时间" align="center" width="150">
          <template #default="{ row }">
            <div class="time-cell">
              <div>{{ formatDate(row.mtime) }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="operator" label="操作人" align="center" width="100">
          <template #default="{ row }">
            <span>{{ row.operator || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" width="420" fixed="right" align="center">
          <template #default="{ row }">
            <div class="operation-buttons">
              <!-- 主要操作 -->
              <div class="primary-actions">
                <el-button type="primary" icon="el-icon-edit" size="mini" @click="dialogShow(false, row)">修改</el-button>
                <el-button type="success" icon="el-icon-pie-chart" size="mini"
                  @click="showRankDialog(row)">排名</el-button>
                <el-button type="primary" icon="el-icon-setting" size="mini" @click="showUnitManage(row)">组件</el-button>
              </div>

              <!-- 更多操作下拉菜单 -->
              <el-dropdown @command="handleCommand" :data="row" size="mini">
                <el-button size="mini" type="info">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{ action: 'copy', row }">
                    <i class="el-icon-document-copy"></i>复制活动
                  </el-dropdown-item>
                  <el-dropdown-item :command="{ action: 'checkAwardsKeys', row }">
                    <i class="el-icon-finished"></i>检查礼包Key
                  </el-dropdown-item>
                  <el-dropdown-item :command="{ action: 'cost', row }">
                    <i class="el-icon-money"></i>查看成本
                  </el-dropdown-item>
                  <el-dropdown-item :command="{ action: 'resetFuse', row }" v-if="row.fuse === 1">
                    <i class="el-icon-refresh"></i>活动熔断恢复
                  </el-dropdown-item>
                  <el-dropdown-item :command="{ action: 'delete', row }" divided>
                    <i class="el-icon-delete"></i>删除活动
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="searchData.page"
        @current-change="getUnitEventList">
      </el-pagination>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <UnitEventDrawer v-model="dialog.visible" :is-edit="dialog.isEdit" @submit="submitChange" :data="dialog.data"
      @refresh="getUnitEventList">
    </UnitEventDrawer>

    <!-- 排名对话框 -->
    <UnitRankDialog v-model="rankDialog.show" :event-data="rankDialog.eventData">
    </UnitRankDialog>

    <!-- 组件管理对话框 -->
    <UnitManageDialog v-model="unitManageDialog.show" :event-data="unitManageDialog.eventData"
      @open-rank-dialog="handleOpenRankFromManage">
    </UnitManageDialog>

    <!-- 导入配置对话框 -->
    <el-dialog title="导入活动配置" :visible.sync="importDialog.show" width="600px">
      <div class="import-config-content">
        <p style="margin-bottom: 10px; color: #666;">请粘贴之前复制的活动配置信息：</p>
        <el-input type="textarea" :rows="12" placeholder="请粘贴JSON配置信息..." v-model="importDialog.configText"
          style="margin-bottom: 15px;">
        </el-input>
        <div style="font-size: 12px; color: #999;">
          <p>提示：</p>
          <p>1. 请确保粘贴的是完整的JSON格式配置信息</p>
          <p>2. 导入后将自动打开新增对话框，您可以修改相关信息后保存</p>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importDialog.show = false">取消</el-button>
        <el-button type="primary" @click="importConfig">确认导入</el-button>
      </div>
    </el-dialog>

    <!-- 成本详情对话框 -->
    <el-dialog :title="costDialog.isQuickQuery ? '活动成本查询结果' : '活动成本详情'" :visible.sync="costDialog.show" width="500px">
      <div class="cost-info-content">
        <!-- 快速查询模式：只显示成本 -->
        <div v-if="costDialog.isQuickQuery" class="quick-cost-result">
          <div class="cost-item">
            <span class="cost-label">活动代码：</span>
            <span class="cost-value">{{ costDialog.eventData.eventCode }}</span>
          </div>
          <div class="cost-item">
            <span class="cost-label">当前成本：</span>
            <span class="cost-value cost-highlight">{{ formatNumber(costDialog.eventData.currCost) || '0' }} 后台金币</span>
          </div>
        </div>

        <!-- 详细模式：显示完整信息 -->
        <div v-else>
          <div class="cost-item">
            <span class="cost-label">活动名称：</span>
            <span class="cost-value">{{ costDialog.eventData.name }}</span>
          </div>
          <div class="cost-item">
            <span class="cost-label">活动代码：</span>
            <span class="cost-value">{{ costDialog.eventData.eventCode }}</span>
          </div>
          <div class="cost-item">
            <span class="cost-label">成本限制：</span>
            <span class="cost-value">{{ formatNumber(costDialog.eventData.maxCostLimit) || '0' }} 后台金币</span>
          </div>
          <div class="cost-item">
            <span class="cost-label">当前成本：</span>
            <span class="cost-value">{{ formatNumber(costDialog.eventData.currCost) || '0' }} 后台金币</span>
          </div>
          <div class="cost-item">
            <span class="cost-label">剩余额度：</span>
            <span class="cost-value" :class="getRemainingClass()">
              {{ formatNumber(getRemainingCost()) || '0' }} 后台金币
            </span>
          </div>
          <div class="cost-item">
            <span class="cost-label">使用率：</span>
            <span class="cost-value">{{ getCostUsageRate() }}%</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="costDialog.show = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { copyToClipboard } from '@/utils/common'
import { getConstList } from '@/api/constRequest'
import { type } from '@/store/index'

import {
  getUnitEventListReq,
  getUnitEventByIdReq,
  deleteUnitEventReq,
  copyUnitEventReq,
  getUnitEventCostReq,
  batchCheckUnitAwardsKeyReq,
  checkUnitAwardsKeyByEventCodeReq,
  resetUnitEventFuseReq
} from '@/api/activityUnitRequest'
import UnitEventDrawer from '@/components/ActivityModelConfig/UnitEventDrawer.vue'
import UnitRankDialog from '@/components/ActivityModelConfig/UnitRankDialog.vue'
import UnitManageDialog from '@/components/ActivityModelConfig/UnitManageDialog.vue'

export default {
  name: 'UnitConfig',
  components: {
    UnitEventDrawer,
    UnitRankDialog,
    UnitManageDialog
  },
  data() {
    return {
      total: 0,
      // 新增：成本查询相关
      costQueryEventCode: '',
      costQueryLoading: false,
      dialog: {
        visible: false,
        isEdit: false,
        data: {}
      },
      rankDialog: {
        show: false,
        eventData: {}
      },
      unitManageDialog: {
        show: false,
        eventData: {}
      },
      importDialog: {
        show: false,
        configText: ''
      },
      costDialog: {
        show: false,
        isQuickQuery: false,
        eventData: {},
        costInfo: {}
      },
      tableData: [],
      searchData: {
        status: 0,
        zoneOffset: '+05:30',
        valid: 1,
        eventCode: '',
        name: '',
        page: 1
      },
      searchConst: {
        status: [
          { value: 0, label: 'ALL' },
          { value: 1, label: '未开始' },
          { value: 2, label: '进行中' },
          { value: 3, label: '已结束' }
        ],
        valid: [
          { value: -1, label: 'ALL' },
          { value: 0, label: '无效' },
          { value: 1, label: '有效' }
        ],
        zoneOffset: []
      }
    }
  },
  computed: {
    tableHeight() {
      // 动态计算表格高度，为成本查询区域留出空间
      return window.innerHeight - 340
    }
  },
  methods: {
    copy(text, desc = '复制成功') {
      copyToClipboard(text, desc)
    },

    // 新增：快速查询活动成本
    async quickQueryCost() {
      if (!this.costQueryEventCode) {
        this.$message.error('请输入活动码')
        return
      }

      this.costQueryLoading = true
      try {
        const res = await getUnitEventCostReq(this.costQueryEventCode)
        if (res.code === 0) {
          // 构造一个临时的活动对象用于显示成本信息
          const tempEventData = {
            name: `活动代码: ${this.costQueryEventCode}`,
            eventCode: this.costQueryEventCode,
            maxCostLimit: 0, // 这里可能需要另外的接口获取完整信息
            currCost: res.data || 0
          }

          this.costDialog = {
            show: true,
            isQuickQuery: true,  // 标识为快速查询模式
            eventData: tempEventData,
            costInfo: {}
          }

          this.$message.success('查询成功')
        } else {
          this.$message.error(res.msg || '查询失败')
        }
      } catch (error) {
        console.error('查询成本失败:', error)
        this.$message.error('查询失败，请检查活动码是否正确')
      } finally {
        this.costQueryLoading = false
      }
    },

    // 格式化日期显示
    formatDate(dateString) {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return `${date.getMonth() + 1}/${date.getDate()} ${date.getHours()}:${date.getMinutes().toString().padStart(2, '0')}`
    },
    // 格式化数字显示
    formatNumber(num) {
      if (!num || num === 0) return '0'
      // 直接显示原值，不进行四舍五入
      return num.toString()
    },
    // 统一展示礼包Key检查结果
    showAwardsKeyResult(list, title = '礼包Key检查结果') {
      const invalidKeys = Array.isArray(list) ? list.filter(item => item) : []
      if (!invalidKeys.length) {
        this.$message.success('所有礼包Key均有效')
        return
      }
      this.$alert(invalidKeys.join('\n'), title, {
        confirmButtonText: '确定'
      })
    },
    // 获取活动状态标签类型
    getStatusTagType(status) {
      switch (status) {
        case '未开始':
          return 'info'
        case '进行中':
          return 'success'
        case '已结束':
          return 'danger'
        default:
          return 'info'
      }
    },
    // 获取剩余成本
    getRemainingCost() {
      const maxCost = this.costDialog.eventData.maxCostLimit || 0
      const currCost = this.costDialog.eventData.currCost || 0
      return maxCost - currCost
    },
    // 获取剩余成本的样式类
    getRemainingClass() {
      const remaining = this.getRemainingCost()
      const maxCost = this.costDialog.eventData.maxCostLimit || 0
      const rate = maxCost > 0 ? (remaining / maxCost) * 100 : 0

      if (rate < 20) return 'cost-danger'
      if (rate < 50) return 'cost-warning'
      return 'cost-success'
    },
    // 获取成本使用率
    getCostUsageRate() {
      const maxCost = this.costDialog.eventData.maxCostLimit || 0
      const currCost = this.costDialog.eventData.currCost || 0

      if (maxCost === 0) return '0'
      return ((currCost / maxCost) * 100).toFixed(1)
    },
    // 批量检查当前行的awardsKeys
    async checkRowAwardsKeys(row) {
      try {
        const res = await checkUnitAwardsKeyByEventCodeReq(row.eventCode)
        if (res.code === 0) {
          this.showAwardsKeyResult(res.data || [], '批量检查结果')
        } else {
          this.$message.error(res.msg || '检查失败')
        }
      } catch (error) {
        this.$message.error('检查礼包Key失败')
      }
    },
    // 按活动码检查礼包Key
    async checkAwardsKeysByEventCode() {
      try {
        const { value: eventCode } = await this.$prompt('请输入活动码', '检查礼包Key', {
          confirmButtonText: '检查',
          cancelButtonText: '取消',
          inputValue: this.costQueryEventCode || '',
          inputPattern: /\S+/,
          inputErrorMessage: '活动码不能为空'
        })

        this.costQueryEventCode = eventCode
        const res = await checkUnitAwardsKeyByEventCodeReq(eventCode)
        if (res.code === 0) {
          this.showAwardsKeyResult(res.data || [], `活动 ${eventCode} 礼包Key检查结果`)
        } else {
          this.$message.error(res.msg || '检查失败')
        }
      } catch (error) {
        if (error === 'cancel' || error === 'close') return
        this.$message.error('检查礼包Key失败')
      }
    },
    // 显示导入配置对话框
    showImportDialog() {
      this.importDialog.show = true
      this.importDialog.configText = ''
    },
    // 导入配置
    importConfig() {
      try {
        if (!this.importDialog.configText.trim()) {
          this.$message.error('请输入配置信息')
          return
        }

        // 解析JSON配置
        const configData = JSON.parse(this.importDialog.configText.trim())

        // 验证配置数据结构
        if (!configData || typeof configData !== 'object') {
          this.$message.error('配置格式不正确')
          return
        }

        // 关闭导入对话框
        this.importDialog.show = false
        this.importDialog.configText = ''

        // 清理不需要的字段（ID、时间戳等）
        const importData = { ...configData }
        delete importData.id
        delete importData.eventCode  // 让系统自动生成新的eventCode
        delete importData.createTime
        delete importData.updateTime
        delete importData.currCost    // 重置当前成本

        // 确保 valid 为 1
        importData.valid = 1

        // 修改活动名称，避免重复
        if (importData.name) {
          importData.name = `${importData.name} - 副本`
        }

        // 自动从组件中收集奖励key
        importData.awardsKeys = this.collectAwardsKeysFromUnits(importData.units || [])

        // 打开新增对话框并填入数据
        this.dialog.isEdit = false
        this.dialog.visible = true
        this.$set(this.dialog, 'data', importData)

        this.$message.success('配置导入成功，请检查并修改相关信息后保存')

      } catch (error) {
        console.error('导入配置错误:', error)
        this.$message.error('配置格式不正确，请检查JSON格式是否有效')
      }
    },

    // 新增：从组件中收集奖励key
    collectAwardsKeysFromUnits(units) {
      const keysSet = new Set()

      units.forEach(unit => {
        // 从不同类型的组件中收集奖励key
        if (unit.awardPoolUnit && unit.awardPoolUnit.awardsKey) {
          keysSet.add(unit.awardPoolUnit.awardsKey)
        }

        if (unit.taskUnit) {
          if (unit.taskUnit.config && unit.taskUnit.config.awardsKey) {
            keysSet.add(unit.taskUnit.config.awardsKey)
          }
          if (unit.taskUnit.configs) {
            unit.taskUnit.configs.forEach(config => {
              if (config.awardsKey) {
                keysSet.add(config.awardsKey)
              }
            })
          }
        }

        if (unit.rankUnit && unit.rankUnit.rewardConfigs) {
          unit.rankUnit.rewardConfigs.forEach(reward => {
            if (reward.awardsKey) {
              keysSet.add(reward.awardsKey)
            }
            // 子榜单奖励Key
            if (reward.sonRankAwardsKey) {
              keysSet.add(reward.sonRankAwardsKey)
            }
          })
        }

        if (unit.stepPoolUnit) {
          if (unit.stepPoolUnit.sonPools) {
            unit.stepPoolUnit.sonPools.forEach(pool => {
              if (pool.awardsKey) {
                keysSet.add(pool.awardsKey)
              }
            })
          }
          if (unit.stepPoolUnit.stepRewards) {
            unit.stepPoolUnit.stepRewards.forEach(reward => {
              if (reward.awardsKey) {
                keysSet.add(reward.awardsKey)
              }
            })
          }
        }

        if (unit.shopUnit && unit.shopUnit.items) {
          unit.shopUnit.items.forEach(item => {
            if (item.awardsKey) {
              keysSet.add(item.awardsKey)
            }
          })
        }

        // 货币合成组件
        if (unit.currencyMergeUnit && unit.currencyMergeUnit.awardsKey) {
          keysSet.add(unit.currencyMergeUnit.awardsKey)
        }
        
        // 分享组件
        if (unit.shareUnit) {
          if (unit.shareUnit.shareAwardsKey) {
            keysSet.add(unit.shareUnit.shareAwardsKey)
          }
          if (unit.shareUnit.shareToAwardsKey) {
            keysSet.add(unit.shareUnit.shareToAwardsKey)
          }
        }
      })

      return Array.from(keysSet).filter(key => key && key.trim())
    },

    async copyUnitEvent(eventCode) {
      const res = await copyUnitEventReq(eventCode)
      if (res.code === 0) {
        // 确保复制的活动的 valid 为 1
        const copyData = { ...res.data }
        copyData.valid = 1
        // 格式化JSON使其更易读
        const formattedJson = JSON.stringify(copyData, null, 2)
        this.copy(formattedJson, '已复制配置信息，可使用"导入配置"功能粘贴使用。')
      } else {
        this.$message.error(res.msg)
      }
    },
    showRankDialog(row) {
      this.rankDialog = {
        show: true,
        eventData: row
      }
    },
    showUnitManage(row) {
      this.unitManageDialog = {
        show: true,
        eventData: row
      }
    },
    // 从组件管理打开排行榜
    handleOpenRankFromManage(eventData) {
      this.rankDialog.show = true
      this.rankDialog.eventData = eventData
    },

    async showCostInfo(row) {
      try {
        const res = await getUnitEventCostReq(row.eventCode)
        if (res.code === 0) {
          this.costDialog = {
            show: true,
            isQuickQuery: false,  // 标识为详细查询模式
            eventData: row,
            costInfo: res.data
          }
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error('获取成本信息失败')
      }
    },
    deleteUnitEvent(info) {
      this.$confirm('此操作将删除该组件化活动, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await deleteUnitEventReq(info)
        if (res.code === 0) {
          this.$message({ type: 'success', message: "删除成功" })
          this.getUnitEventList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => { });
    },
    submitChange() {
      this.dialog.visible = false
      this.getUnitEventList()
    },
    // isAdd 是否为新增
    async dialogShow(isAdd, row) {
      // 编辑模式，先检查活动状态
      if (!isAdd) {
        // 优先判断 valid，如果为0就不允许编辑
        if (row.valid === 0) {
          this.$message.error('活动无效，无法修改')
          return
        }
        // 如果 valid 为 1，再判断 endTime 是否小于现在时间
        if (row.valid === 1 && row.endTime) {
          const endTime = new Date(row.endTime)
          const now = new Date()
          if (endTime < now) {
            this.$message.error('活动时间已结束，无法修改')
            return
          }
        }
        // 如果活动正在进行中，显示二次确认框
        if (row && row.activeStatus === '进行中') {
          const envText = type === 1 ? '测试服' : '正式服'
          try {
            await this.$confirm(
              `当前活动正在进行中，您正在${envText}环境操作。是否确认修改当前活动？`,
              '确认修改',
              {
                confirmButtonText: '确认修改',
                cancelButtonText: '取消',
                type: 'warning'
              }
            )
          } catch {
            // 用户取消，直接返回
            return
          }
        }

        const lockSuccess = await this.$editLock.lock('resource_type_event_unit', row.id, true)

        if (!lockSuccess) {
          return
        }

        // lockSuccess为true时根据ID重新获取最新的数据
        try {
          const res = await getUnitEventByIdReq(row.id)
          if (res.code === 0) {
            row = res.data
          } else {
            this.$message.error(res.msg || '获取最新数据失败')
            return
          }
        } catch (error) {
          console.error('获取最新数据失败:', error)
          this.$message.error('获取最新数据失败')
          return
        }
      }

      // 通过检查后再设置对话框状态
      this.dialog.isEdit = !isAdd;
      this.dialog.visible = true;

      if (!isAdd) {
        this.$set(this.dialog, 'data', { ...row })

        // 处理notJoinRidSet数据格式
        if (row.notJoinRidSet && row.notJoinRidSet.length > 0) {
          if (row.notJoinRidSet.length > 1) {
            this.dialog.data.notJoinRidSet = row.notJoinRidSet.join(',')
          } else {
            this.dialog.data.notJoinRidSet = row.notJoinRidSet[0].toString()
          }
        }

        // 自动从组件中收集奖励key（编辑时）
        if (row.units) {
          this.dialog.data.awardsKeys = this.collectAwardsKeysFromUnits(row.units)
        }
      } else {
        // 新增模式
        this.dialog.data = {}
      }
    },
    async getUnitEventList() {
      const res = await getUnitEventListReq(this.searchData)
      if (res.code === 0) {
        this.tableData = res.data.data
        this.total = res.data.total
        this.$message({ type: 'success', message: "查询成功" })
      } else {
        this.$message.error(res.msg)
        this.tableData = []
      }
    },
    handleCommand(command) {
      const { action, row } = command
      switch (action) {
        case 'copy':
          this.copyUnitEvent(row.eventCode)
          break
        case 'checkAwardsKeys':
          this.checkRowAwardsKeys(row)
          break
        case 'cost':
          this.showCostInfo(row)
          break
        case 'resetFuse':
          this.resetFuse(row)
          break
        case 'delete':
          this.deleteUnitEvent(row)
          break
        default:
          break
      }
    },
    // 活动熔断恢复
    async resetFuse(row) {
      try {
        const { value: resetFuseKey } = await this.$prompt('请输入重置密钥', '活动熔断恢复', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'text',
          inputPattern: /\S+/,
          inputErrorMessage: '重置密钥不能为空'
        })

        const res = await resetUnitEventFuseReq({
          eventCode: row.eventCode,
          username: this.$store.getters.username,
          resetFuseKey: resetFuseKey
        })

        if (res.code === 0) {
          this.$message.success('活动熔断恢复成功')
          this.getUnitEventList()
        } else {
          this.$message.error(res.msg || '活动熔断恢复失败')
        }
      } catch (error) {
        if (error === 'cancel' || error === 'close') return
        this.$message.error('活动熔断恢复失败')
      }
    }
  },
  async mounted() {
    const constRes = await getConstList('timeZone')
    if (constRes.code === 0) {
      this.searchConst.zoneOffset = constRes.data
      this.searchData.zoneOffset = constRes.data[0].value
    }
    this.getUnitEventList()
  }
}
</script>

<style scoped lang="scss">
.unit-activity-config {
  .el-card {
    height: calc(100vh - 56px);
  }

  &__header {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 16px;
  }

  &__search {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
    align-items: flex-end;
    margin-bottom: 16px;
  }
}

.search-item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 240px;

  .el-select,
  .el-input {
    flex: 1;
    width: 180px;
    margin-left: 0;
  }
}

.search-label {
  min-width: 64px;
  text-align: right;
  color: #666;
  font-size: 13px;
}

.search-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

// 新增：成本查询区域样式
.cost-query-section {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding: 12px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e9ecef;
}

/* 表格基础样式 */
::v-deep .el-table {
  .el-table__body-wrapper {
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 3px;

      &:hover {
        background: #a1a1a1;
      }
    }
  }
}

.operation-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
  /* 防止换行 */
  min-width: 400px;
  /* 确保最小宽度 */

  .primary-actions {
    display: flex;
    gap: 4px;
    flex-wrap: nowrap;
    /* 主要操作不换行 */

    .el-button {
      margin: 0 !important;
      font-size: 12px;
      padding: 4px 8px;
      /* 更紧凑的内边距 */
      white-space: nowrap;
      /* 文字不换行 */
    }
  }

  .el-dropdown {
    .el-button {
      margin: 0 !important;
      font-size: 12px;
      padding: 4px 8px;
      white-space: nowrap;
    }
  }
}

/* 下拉菜单项样式 */
.el-dropdown-menu__item {
  i {
    margin-right: 5px;
    width: 14px;
    text-align: center;
  }
}

/* 基础表格样式 */
.time-cell {
  font-size: 12px;
  line-height: 1.2;

  .time-divider {
    margin: 2px 0;
  }
}

.url-cell {
  display: flex;
  align-items: center;
  gap: 4px;

  .url-link {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .copy-btn {
    padding: 2px 4px;
    font-size: 11px;
  }
}

.cost-cell {
  font-size: 12px;

  div {
    margin-bottom: 2px;
  }
}

/* 导入配置对话框样式 */
.import-config-content {
  .el-textarea__inner {
    font-family: 'Courier New', monospace;
    font-size: 12px;
    line-height: 1.4;
  }

  p {
    margin: 4px 0;
    line-height: 1.4;
  }
}

/* 成本详情对话框样式 */
.cost-info-content {
  .cost-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }

    .cost-label {
      font-weight: bold;
      color: #333;
      min-width: 80px;
    }

    .cost-value {
      color: #666;
      font-family: 'Courier New', monospace;

      &.cost-success {
        color: #67C23A;
      }

      &.cost-warning {
        color: #E6A23C;
      }

      &.cost-danger {
        color: #F56C6C;
      }

      &.cost-highlight {
        font-size: 16px;
        font-weight: bold;
        color: #409EFF;
      }
    }
  }

  .quick-cost-result {
    text-align: center;
    padding: 20px 0;

    .cost-item {
      justify-content: center;
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>